import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  DeleteInfo,
  DeletePopup
} from '../../../../Component/LeadWaitList/LeadWaitList.styles';
import Button from '../../../../globalcomponents/Button';
import PopupBody from '../../../../globalcomponents/PopupComponents/PopupBody';
import PopupFooter from '../../../../globalcomponents/PopupComponents/PopupFooter';
import { deleteLeadWaitlist } from '../../../../Redux/util/Apis/leads';
import { setGlobalError } from '../../../../Redux/Reducer/GlobalError';

const WaitListDeletePopup = ({
  leadId,
  existingDate,
  handleCancelDelete,
  handleEmptyWaitlistData,
  refetchLeadInfo
}) => {
  const [isItemDeleted, setIsItemDeleted] = useState(false);
  const dispatch = useDispatch();
  const deleteItem = async () => {
    const result = await deleteLeadWaitlist(leadId, existingDate);
    if (result?.error) {
      dispatch(setGlobalError(result.message));
      return;
    }
    setIsItemDeleted(true);
    handleEmptyWaitlistData();
    refetchLeadInfo?.();
  };
  return (
    <DeletePopup>
      <PopupBody>
        {isItemDeleted ? (
          <DeleteInfo>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '10px'
              }}
            >
              <img src="/deleteWaitConfirm.png" />
            </div>
            <div> Waitlist Deleted!</div>
          </DeleteInfo>
        ) : (
          <DeleteInfo>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '10px'
              }}
            >
              <img src="/DeleteWait.svg" />
            </div>
            <div>Waitlist will be deleted. Are you sure?</div>
          </DeleteInfo>
        )}
      </PopupBody>
      {isItemDeleted ? null : (
        <PopupFooter justifyContent="center">
          <Button onClick={handleCancelDelete}>No</Button>
          <Button onClick={deleteItem} noStyle={true}>
            Delete
          </Button>
        </PopupFooter>
      )}
    </DeletePopup>
  );
};

export default WaitListDeletePopup;
